import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b893427"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__dialog" }
const _hoisted_2 = {
  key: 0,
  class: "__box"
}
const _hoisted_3 = { class: "__scales u-flex-center-stretch" }
const _hoisted_4 = { class: "__number" }
const _hoisted_5 = { class: "__tags u-flex-start-start u-flex-wrap" }
const _hoisted_6 = { class: "__rectangles" }
const _hoisted_7 = { class: "u-flex-center-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "__text u-capital-case u-bold" }, "close", -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pallet_detail_code = _resolveComponent("pallet-detail-code")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.data.isShowDialog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propsColor.code, (hex) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: hex,
                    class: "__scale u-flex-shrink-1",
                    style: _normalizeStyle({background: hex})
                  }, null, 4 /* STYLE */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.propsColor.id), 1 /* TEXT */),
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propsColor.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: tag,
                    class: "__tag u-capital-case u-bold"
                  }, _toDisplayString(tag), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propsColor.code, (hex) => {
                  return (_openBlock(), _createBlock(_component_pallet_detail_code, {
                    key: hex,
                    "props-code": hex
                  }, null, 8 /* PROPS */, ["props-code"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "u-button-default u-button-default--negative",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDetails()))
                }, _hoisted_9)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}